import { PickingPicker } from "../../components/picking-picker.tsx";

export function DispatchList() {
  return (
    <PickingPicker
      workflow="dispatch"
      title="Goods Dispatch"
      accent="green"
      placeholder="e.g. PMWH/OUT/00001"
    />
  );
}
